// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'condition-satisfactory';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round'>
    <rect width='11' height='11' x='3.5' y='3.5' rx='1' transform='rotate(45 9 9)' />
    <path d='M6 9h6' />
  </g>
);

export const viewBox = '0 0 18 18';
